module.exports = __webpack_public_path__ + "img/close.67afc2ec.png";